
class ControllerRedefinirSenha {
  constructor(usuario, setUsuario, errors, setErrors, setLoading, setShowSuccess) {
    this.usuario = usuario;
    this.setUsuario = setUsuario;
    this.errors = errors;
    this.setErrors = setErrors;
    this.setLoading = setLoading;
    this.setShowSuccess = setShowSuccess;

  }

  async handlerSubmit(e, token) {
    e.preventDefault();
    alert('Email de exclusão de conta enviado com sucesso');
    setTimeout(() => {
      window.location.href = '/login';
    }, 1000);
  }
}

export default ControllerRedefinirSenha;
